var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-tabs",
        {
          attrs: {
            "show-arrows": "",
            "background-color": "blue-grey lighten-5",
          },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.groups, function (group) {
          return _c("v-tab", { key: group.uid }, [
            _vm._v(" " + _vm._s(group.kind.name) + " "),
          ])
        }),
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "mt-4",
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.groups, function (group) {
          return _c(
            "v-tab-item",
            { key: group.uid },
            [
              _c(
                "v-card",
                [
                  _c("ac-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.getProducts(group),
                      "item-class": _vm.row_class,
                      "sort-by": "name",
                      "item-key": "uid",
                      "fixed-header": "",
                      "footer-props": _vm.footer,
                      "items-per-page": 50,
                      height: _vm.winsize.height - 220 - 36,
                      search: _vm.search,
                      "can-select": (item) => !_vm.row_readonly(item),
                      "can-delete": (item) => !_vm.row_readonly(item),
                      "remove-bulk": _vm.bulkRemove,
                      "bulk-mode": _vm.bulkMode,
                      title: "Configs",
                    },
                    on: {
                      "update:search": function ($event) {
                        _vm.search = $event
                      },
                      "update:bulkMode": function ($event) {
                        _vm.bulkMode = $event
                      },
                      "update:bulk-mode": function ($event) {
                        _vm.bulkMode = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "actions",
                          fn: function () {
                            return [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.row_create(group)
                                    },
                                  },
                                },
                                [_vm._v(" New Config ")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "accent" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.show_preview(group)
                                    },
                                  },
                                },
                                [_vm._v(" Preview JSON ")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "item.consumable",
                          fn: function ({ item }) {
                            return [
                              _c("div", { attrs: { align: "center" } }, [
                                _vm._v(_vm._s(item.consumable ? "ON" : "OFF")),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.enabled",
                          fn: function ({ item }) {
                            return [
                              _c("div", { attrs: { align: "center" } }, [
                                _vm._v(_vm._s(item.enabled ? "ON" : "OFF")),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.icon",
                          fn: function ({ item }) {
                            return [
                              _c("v-image-view", {
                                staticStyle: { width: "50px", height: "50px" },
                                attrs: { path: _vm.getImage(item) },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.price",
                          fn: function ({ item }) {
                            return [
                              item.payment === 0
                                ? _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      item.price.length > 0
                                        ? _c("v-icon", [
                                            _vm._v("mdi-currency-usd"),
                                          ])
                                        : _c("v-label", [_vm._v("-")]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.payment === 1
                                ? _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [_c("v-icon", [_vm._v("mdi-cart")])],
                                    1
                                  )
                                : _vm._e(),
                              item.payment === 2
                                ? _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [_c("v-icon", [_vm._v("mdi-help-box")])],
                                    1
                                  )
                                : _vm._e(),
                              item.payment === 3
                                ? _c(
                                    "div",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-advertisements"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _vm.row_readonly(item)
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "green" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.row_view(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" mdi-eye ")]
                                  )
                                : item.locked
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "orange" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.row_update(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" mdi-pencil ")]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "", color: "green" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.row_update(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" mdi-pencil ")]
                                  ),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { small: "", color: "teal lighten-1" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.row_copy(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-content-copy ")]
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    disabled: item.global || item.shared,
                                    small: "",
                                    color: "blue",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.row_export(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-briefcase-upload ")]
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    disabled: _vm.row_readonly(item),
                                    small: "",
                                    color: "red",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.row_remove(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-delete ")]
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    disabled: item.global || item.shared,
                                    small: "",
                                    color: "blue",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.row_convert(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-cloud-upload-outline ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: "no-results",
                          fn: function () {
                            return [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: true,
                                    color: "blue-grey",
                                    dense: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    ' Your search for "' +
                                      _vm._s(_vm.search) +
                                      '" found no results. '
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c("r-product-dialog", { ref: "product-dialog" }),
      _c("r-dialog-preview-collection", { ref: "previewCollection" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }